import { render, staticRenderFns } from "./CashReceipts.vue?vue&type=template&id=6ad13302&scoped=true"
import script from "./CashReceipts.vue?vue&type=script&lang=js"
export * from "./CashReceipts.vue?vue&type=script&lang=js"
import style0 from "./CashReceipts.vue?vue&type=style&index=0&id=6ad13302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad13302",
  null
  
)

export default component.exports